import { assertNever } from "../assert-never";
import type { TranslatableValue} from "../translations/translation";
import { translation } from "../translations/translation";

/**
 * Represents the names of weekdays in different languages.
 * Week starts at Monday.
 */
const weekdayNames: {
    long: {
        singular: [
            TranslatableValue, // Måndag
            TranslatableValue, // Tisdag
            TranslatableValue, // Onsdag
            TranslatableValue, // Torsdag
            TranslatableValue, // Fredag
            TranslatableValue, // Lördag
            TranslatableValue, // Söndag
        ];
        plural: [
            TranslatableValue,
            TranslatableValue,
            TranslatableValue,
            TranslatableValue,
            TranslatableValue,
            TranslatableValue,
            TranslatableValue,
        ];
    };
    short: [
        TranslatableValue,
        TranslatableValue,
        TranslatableValue,
        TranslatableValue,
        TranslatableValue,
        TranslatableValue,
        TranslatableValue,
    ];
} = {
    long: {
        singular: [
            translation({
                sv: "måndag",
                en: "Monday",
                de: "Montag",
            }),
            translation({
                sv: "tisdag",
                en: "Tuesday",
                de: "Dienstag",
            }),
            translation({
                sv: "onsdag",
                en: "Wednesday",
                de: "Mittwoch",
            }),
            translation({
                sv: "torsdag",
                en: "Thursday",
                de: "Donnerstag",
            }),
            translation({
                sv: "fredag",
                en: "Friday",
                de: "Freitag",
            }),
            translation({
                sv: "lördag",
                en: "Saturday",
                de: "Samstag",
            }),
            translation({
                sv: "söndag",
                en: "Sunday",
                de: "Sonntag",
            }),
        ],
        plural: [
            translation({
                sv: "måndagar",
                en: "Mondays",
                de: "Montage",
            }),
            translation({
                sv: "tisdagar",
                en: "Tuesdays",
                de: "Dienstage",
            }),
            translation({
                sv: "onsdagar",
                en: "Wednesdays",
                de: "Mittwoche",
            }),
            translation({
                sv: "torsdagar",
                en: "Thursdays",
                de: "Donnerstage",
            }),
            translation({
                sv: "fredagar",
                en: "Fridays",
                de: "Freitage",
            }),
            translation({
                sv: "lördagar",
                en: "Saturdays",
                de: "Samstage",
            }),
            translation({
                sv: "söndagar",
                en: "Sundays",
                de: "Sonntage",
            }),
        ],
    },
    short: [
        translation({
            sv: "mån",
            en: "Mon",
            de: "Mo",
        }),
        translation({
            sv: "tis",
            en: "Tue",
            de: "Di",
        }),
        translation({
            sv: "ons",
            en: "Wed",
            de: "Mi",
        }),
        translation({
            sv: "tor",
            en: "Thu",
            de: "Do",
        }),
        translation({
            sv: "fre",
            en: "Fri",
            de: "Fr",
        }),
        translation({
            sv: "lör",
            en: "Sat",
            de: "Sa",
        }),
        translation({
            sv: "sön",
            en: "Sun",
            de: "So",
        }),
    ],
};

const getWeekdayIndex = (
    day:
        | "Monday"
        | "Tuesday"
        | "Wednesday"
        | "Thursday"
        | "Friday"
        | "Saturday"
        | "Sunday",
) => {
    switch (day) {
        case "Monday":
            return 0;
        case "Tuesday":
            return 1;
        case "Wednesday":
            return 2;
        case "Thursday":
            return 3;
        case "Friday":
            return 4;
        case "Saturday":
            return 5;
        case "Sunday":
            return 6;
        default:
            assertNever(day);
    }
};

export { weekdayNames, getWeekdayIndex };
